export default {
  menu: {
    home: '首頁',
    alliance: '我的聯盟',
    mall: '口袋商城',
    me: '關於我們'
  },
  layout: {
    loading: '載入中',
    trading: '交易中，請稍候...',
    comingsoon: '即將到來',
    success: '成功',
    error: '失敗'
  },
  header: {
    home: '首頁',
    alliance: '我的聯盟',
    mall: '口袋商城',
    about: '關於我們',
    lang: {
      zh: '簡體中文',
      zhTW: '繁體中文',
      en: 'English',
      ko: '한국어',
      ja: '日本語'
    }
  },
  period: {
    m5: '5分',
    m15: '15分',
    h1: '1小時',
    h4: '4小時',
    d1: '日',
    w1: '週',
    m1: '月'
  },
  home: {
    slogan1: '讓資產增值',
    slogan2_part1: '從',
    slogan2_pocket: '口袋',
    slogan2_part2: '開始',
    slogan3: '安全·穩健·高收益',
    explore: '探索更多',
    alliance_pack: '口袋聯盟配套',
    alliance_desc: '最高可開出價值5000元珍藏卡牌，贈送口袋通證，累計最高可享360元福利回饋！',
    join_alliance: '加入口袋聯盟',
    mall: '口袋商城',
    mall_desc: '不只是購物，更是一種儲蓄。',
    ecosystem: '戰略夥伴 - DRS',
    ecosystem_desc: '為合作社賦能，為公務員減負。',
    referrer_title: '推薦人地址',
    referrer_placeholder: '請輸入推薦人地址',
    confirm: '確認'
  },
  alliance: {
    mint_pool: '鑄幣池',
    token_count: 'TOKEN數量',
    usdt_total: 'USDT總量',
    open_price: '開盤價',
    current_value: '當前價值',
    static_income: '靜態收益',
    my_token: '我的TOKEN數量',
    withdraw: '提現',
    fill_address: '填寫地址',
    view_receipt: '查看收貨',
    dynamic_income: '動態收益',
    current_node: '當前為',
    large_node: '大節點',
    repurchase_count: '復購次數',
    current_pack: '當前配套',
    max_return: '最大收益',
    withdrawn_income: '已提現收益',
    current_income: '當前收益',
    my_pack: '我的配套',
    referrer_address: '推薦人地址',
    community_subsidy: '社區補貼',
    buy_node: '購買節點',
    my_team: '我的團隊',
    team_pack: '團隊配套',
    team_small_node: '團隊小節點',
    team_large_node: '團隊大節點',
    my_referrals: '我的推薦',
    node: '節點',
    date: '日期',
    small_node: '小節點',
    recommend: '推薦',
    high_return: '高收益',
    buy: '購買',
    small_node_desc: '適合個人使用，性價比高，輕鬆參與生態建設',
    large_node_desc: '適合個人用戶，性價比高，輕鬆參與生態建設',
    fill_receipt_info: '填寫收貨資訊',
    select_region: '選擇地區',
    select_address: '地址',
    receiver: '收貨人',
    phone: '聯絡電話',
    submit: '確認提交',
    cancel: '取消',
    purchase_node: '購買節點',
    select_node: '選擇您要購買的節點',
    your_address: '您的收貨地址',
    your_phone: '您的聯絡電話',
    shipping_status: '發貨狀態',
    shipp: '待發貨',
    shipped: '已發貨',
    shipping_method: '快遞方式',
    tracking_number: '快遞單號',
    close: '確認關閉',
    postcode: '郵遞區號',
    endvalue: '最終收益',
    copylink: '複製邀請連結',
    fundinfo: '明細',
    myorder: '我的訂單',
    orderno: '訂單號',
    getthings: '領取',
    geted: '已領取',
    gettime: '領取時間',
    packamount: '配套金額',
    nonode: '暫無',
    teamsub: '社區補貼',
    pocketname: '口袋聯盟',
    pocketname1: '感謝您的支持與參與！',
    pocketname2: '請前往指定線下門市領取商品。祝您好運連連，抽中心儀珍藏卡！',
    nodealert:'需要推薦',
    nodealert2:'人',
  },
  me: {
    about_alliance: '關於口袋聯盟',
    alliance_rule1: '口袋聯盟是一個以 Web3 為核心的創新生態聯盟，致力於打造一個集消費增值、儲蓄增值、收藏增值、金融增值於一體的價值生態系統。',
    alliance_rule2: '我們希望透過簡單、易懂、低門檻的方式，讓更多普通人能夠接觸並參與 Web3 時代的發展機會，實現財富價值的長期積累與增長。',
    alliance_rule3: '口袋聯盟以桌遊社交為入口，透過輕鬆有趣的互動方式建立人與人之間的信任與連結；以社區共建為基礎，透過分享、學習與協作，構建一個充滿活力的價值網絡。',
    alliance_rule4: '在口袋聯盟生態中，消費不再只是支出，儲蓄不再只是沉澱，收藏不再只是愛好，而是能夠持續創造價值的生態循環。',
    alliance_rule5: '我們的願景',
    alliance_rule6: '讓每一個人都擁有屬於自己的價值口袋，在 Web3 時代鎖定財富、積累財富、傳承財富。',
    alliance_rule7: '我們的使命',
    alliance_rule8: '以社交連接價值，以生態創造增值，讓 Web3 走進千家萬戶。',
    alliance_rule9: '我們的核心價值',
    alliance_rule10: '💰 消費增值 —— 讓每一次消費更有價值',
    alliance_rule11: '🏦 儲蓄增值 —— 讓資金擁有成長的機會',
    alliance_rule12: '🃏 收藏增值 —— 讓興趣成為資產',
    alliance_rule13: '📈 金融增值 —— 讓價值實現持續流動',
    alliance_rule14: '🤝 社區共建 —— 讓分享創造更大價值',
    alliance_rule15: '🌐 Web3賦能 —— 讓人人都能參與未來經濟',
    alliance_rule16: '口袋聯盟——把消費變成資產，把社交變成價值，把未來裝入口袋。',
    alliance_rule17: '口袋聯盟-讓會員口袋都有錢',
    about_node: '關於節點',
    node_rule1: '1. 投資300U，成為小節點',
    node_rule2: '2. 投資800U，成為大節點',
    pocketname: '口袋通證',
    pocketprice: '當前市值',
    pockettrade: '交易額',
},
  mall: {
    coming_soon: '即將到來...'
  },
  chart: {
    open: '開盤',
    close: '收盤',
    high: '最高',
    low: '最低',
    change: '漲跌額',
    change_rate: '漲跌幅',
    volume: '成交量'
  }
};